export default __webpack_public_path__ + "./img/workspaces-registry.a83fe568b708290ae00a19c28e9dc8c2.gif";